export enum ChartType {
    Bar = 'bar',
    Pie = 'pie',
  }
  